import React, { useEffect, useState } from 'react'
import { Card, Skeleton, Dropdown, Menu, message } from 'antd'
import { useEventSelector } from 'store/eventSlice/eventReducer'
import { config } from 'configs'
import { formatAmount } from 'utils'
import moment from 'moment'
import { IoIosArrowDropdownCircle } from 'react-icons/io'
import { useDispatch } from 'react-redux'
import Api from 'api'
import { getEventControlScreenDetails } from 'store/eventSlice/eventActions'
import { InfiniteScrollContainer } from 'components/elements'

function PendingCash() {
  const dispatch = useDispatch()
  const { loading, eventDetail } = useEventSelector()
  const [data, setData] = useState([])
  const [current, setCurrent] = useState([])

  useEffect(() => {
    if (eventDetail?.pendingCash?.length > 0) {
      setData(eventDetail?.pendingCash)
      setCurrent(eventDetail?.pendingCash?.slice(0, config.rowsPerPage))
    }
    // eslint-disable-next-line
  }, [eventDetail])

  const onClick = async (id, Status, eventId) => {
    const data1 = {
      id,
      Status,
    }
    Api.put('/presenter/changeCashStatus', data1)
      .then(() => {
        dispatch(getEventControlScreenDetails(eventId))
        message.success('Cash Status Updated')
      })
      .catch((error) => {
        console.log('error', error)
        message.error(error?.response?.data?.message || 'Something went wrong')
      })
  }

  const customMenu = (id, eventId) => (
    <Menu>
      <Menu.Item
        key={1}
        onClick={() => onClick(id, 'Completed', eventId)}
        id="pending-cash-options-dropdown-accept"
      >
        Accept
      </Menu.Item>
      <Menu.Item
        key={2}
        onClick={() => onClick(id, 'Rejected', eventId)}
        id="pending-cash-options-dropdown-reject"
      >
        Reject
      </Menu.Item>
    </Menu>
  )

  return (
    <Card className="t-w-full">
      <Skeleton loading={loading} active paragraph={{ rows: 12 }}>
        <div className="t-h-80" id="pending-cash-list">
          {data.length === 0 && (
            <div className="t-flex t-justify-center t-items-center t-h-full t-w-full">
              No Pending Cash
            </div>
          )}
          {data.length > 0 && (
            <InfiniteScrollContainer
              data={data}
              current={current}
              setCurrent={setCurrent}
              height="265px"
              itemsFirstLoad={config.rowsPerPage}
            >
              <>
                {current.map((item, index) => (
                  <div
                    key={index}
                    className={`t-w-full t-rounded-2xl t-h-12 t-p-3 ${
                      true ? 't-bg-yellow-100' : 't-bg-red-100'
                    } t-text-secondary-100 t-mb-2 t-flex t-items-center t-shadow-md t-justify-between`}
                  >
                    <div className="t-flex t-space-x-2 t-items-center">
                      <div className="t-w-8 t-h-8 t-rounded-full t-flex t-items-center t-justify-center t-bg-primary-100 t-p-2 t-shadow-lg t-text-white t-font-bold">
                        {item.DonorName
                          ? item.DonorName.substring(0, 1).toUpperCase()
                          : ''}
                      </div>
                      <h1 className="t-font-bold t-text-xs md:t-text-sm">
                        {`${item.DonorName} wants to donate from Table-${item?.Table}`}
                      </h1>
                    </div>
                    <div className="t-flex t-flex-col">
                      <h2 className="t-font-bold t-text-secondary-100 t-text-right t-text-xs md:t-text-sm">
                        {formatAmount(item.Amount)}
                      </h2>
                      <h2 className="t-text-gray-800 t-italic t-text-xs md:t-text-sm t-whitespace-nowrap t-text-right">
                        {moment(moment.utc(item.PaymentDate)).local().fromNow()}
                      </h2>
                    </div>
                    <div>
                      <Dropdown overlay={customMenu(item?.id, item?.EventId)}>
                        <IoIosArrowDropdownCircle
                          fontSize="1.5rem"
                          id="pending-cash-options-dropdown"
                          className="t-text-secondary-100 t-cursor-pointer"
                        />
                      </Dropdown>
                    </div>
                  </div>
                ))}
              </>
            </InfiniteScrollContainer>
          )}
        </div>
      </Skeleton>
    </Card>
  )
}

export { PendingCash }
